// extracted by mini-css-extract-plugin
export default {"loadingDots":"KcJv1U","dot":"qKnPnG","dotPulse":"TRu4xY"};